import React, { Component } from "react";
import { connect } from "react-redux";
import Authenticator from "../../../services/Authenticator";
import {
  fetchCeoCircle,
  createCeoCircleAwardee,
  updateCeoCircleAwardee,
  deleteCeoCircleAwardee,
  searchCeoCircleEmployees,
  fetchCeoCircleBhrPhoto,
} from "../../../store/actions/ceoCircle/ceoCircleActions";
import CeoCircleCarousel from "./CeoCircleCarousel";
import CeoCircleForm from "./CeoCircleForm";
import "./CeoCircle.css";
import { ContainerBody, Content } from "../../../components/GridComponent/AdminLte.js";
import Wrapper from "../../Template/Wrapper";

/**
 * CEO Circle of Excellence — Dashboard tab container.
 * Loads the hall of fame, decides whether the viewer is HR, and wires the carousel to the
 * add / edit / remove modal and the redux actions.
 */
class CeoCircle extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showForm: false,
      editing: null, // the awardee being edited, or null for "add"
    };
    this.currentYear = new Date().getFullYear();
  }

  componentDidMount() {
    this.props.fetchCeoCircle();
  }

  onAdd = () => this.setState({ showForm: true, editing: null });

  onEdit = (awardee) => this.setState({ showForm: true, editing: awardee });

  onHide = () => this.setState({ showForm: false, editing: null });

  onRemove = (awardee) => {
    const ok = window.confirm("Remove " + awardee.name + " (" + awardee.year + ") from the CEO Circle of Excellence?");
    if (ok) this.props.deleteCeoCircleAwardee(awardee.id);
  };

  // The form owns the 422 display; the action owns every other alert. Rejections reach the form.
  onSubmit = (formData) => {
    const { editing } = this.state;
    return editing
      ? this.props.updateCeoCircleAwardee(editing.id, formData)
      : this.props.createCeoCircleAwardee(formData);
  };

  render() {
    const isHr = !!Authenticator.scanLevel("HR");
    const store = this.props.ceoCircle || {};
    const awardees = Array.isArray(store.list) ? store.list : [];

    // Nothing is shown (not even the teaser) until the first list has arrived, so a slow or
    // failed fetch never looks like "nobody has won yet".
    if (!store.isListLoaded) {
      return (
        <div className="ceo-circle">
          {store.loadError ? (
            <p className="ceo-state" role="status">Couldn't load the CEO Circle right now.</p>
          ) : (
            <p className="ceo-state" role="status" aria-busy="true">
              <i className="fa fa-spinner fa-spin" aria-hidden="true" />
              Loading the CEO Circle of Excellence…
            </p>
          )}
        </div>
      );
    }

    return (
      <div>
        <Wrapper>
          <ContainerBody>
            <Content col="12" label="CEO Circle">
              <div className='heading-style'>
                {/* <h3 className='download-header'>Download Policies Document</h3> */}
              </div>
              <div className="ceo-circle-wrap">
                <CeoCircleCarousel
                  awardees={awardees}
                  currentYear={this.currentYear}
                  isHr={isHr}
                  onEdit={this.onEdit}
                  onRemove={this.onRemove}
                  onAdd={this.onAdd}
                />
                {isHr && (
                  <CeoCircleForm
                    show={this.state.showForm}
                    onHide={this.onHide}
                    awardee={this.state.editing}
                    currentYear={this.currentYear}
                    searchEmployees={this.props.searchCeoCircleEmployees}
                    fetchBhrPhoto={this.props.fetchCeoCircleBhrPhoto}
                    onSubmit={this.onSubmit}
                  />
                )}
              </div>
            </Content>
          </ContainerBody>
        </Wrapper>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ceoCircle: state.ceoCircle,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchCeoCircle: () => dispatch(fetchCeoCircle()),
    createCeoCircleAwardee: (data) => dispatch(createCeoCircleAwardee(data)),
    updateCeoCircleAwardee: (id, data) => dispatch(updateCeoCircleAwardee(id, data)),
    deleteCeoCircleAwardee: (id) => dispatch(deleteCeoCircleAwardee(id)),
    searchCeoCircleEmployees: (q) => dispatch(searchCeoCircleEmployees(q)),
    fetchCeoCircleBhrPhoto: (userId) => dispatch(fetchCeoCircleBhrPhoto(userId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CeoCircle);
